import ReportProxy from '@/proxies/Reports/ReportProxy';

export default {
  data() {
    return {
      reportMethodName: 'ordersBaseListingReport',
    };
  },
  methods: {
    onDownloadExcel() {
      this.$store.dispatch('page/displaySnackbar', {
        text: this.lang(this.$store, 'sap/listings.global.send_request_report'),
        color: 'pink darken-3',
        timeout: 10000,
      });
      const proxy = new ReportProxy()
        .setParameters(this.searchParams);
      proxy[this.reportMethodName]()
        .then(response => {
          // console.warn(response);
          if (response.data.data.url) {
            window.open(response.data.data.url, '_blank');
          }
          if (response.data.data.url_csv) {
            window.open(response.data.data.url_csv, '_blank');
          }
        })
        .catch(error => {
          switch (error.status) {
            case 422:
              setTimeout(() => {
                this.$store.dispatch('page/displaySnackbar', {
                  text: error.data.data.error,
                  color: 'red darken-3',
                  timeout: 6000,
                });
              }, 500);
              break;
            default:
              console.error(error);
              alert('Error while requesting');
              break;
          }
        })
        .finally(() => {
          this.$store.dispatch('page/hideSnackbar');
        });
    },
  },
};
